import React from 'react';
import { useUserList } from '@utils/hooks/useUserList';
import SmallVideoBlock from '@component/studio/small-video-block';
import useImmersiveMode from '@utils/hooks/useImmersiveMode';
import { isMobileBrowser } from '@utils/browser';

const isPhone = isMobileBrowser();
const LecturerRight: React.FC = () => {
  const videoList = useUserList();
  const immersiveMode = useImmersiveMode();

  return (
    <div
      className={`lecturer-mode__right ${isPhone ? 'lecturer-mode-phone__right' : ''}`}
      style={isPhone ? { paddingTop: immersiveMode ? '0' : '30px', flexBasis: immersiveMode ? '120px' : '150px' } : {}}
    >
      <div className={`lecturer-mode__right__container ${isPhone ? 'lecturer-mode-phone__right__container' : ''}`}>
        {videoList.map((item) => (
          // 这里的 key 不能使用 appUid,因为共享流的 appUid 和主流是一样的，还需要新增一个 streamType 一起判断
          <SmallVideoBlock
            user={item}
            key={`${item?.id?.['@app_uid']}-${item?.id?.['@instance_id']}-${item?.rtcStream?.streamType}`}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(LecturerRight);
